export default "__VITE_ASSET__hmXsKfCX__"